import EmberObject from '@ember/object';
import { ActionHandler } from '@ember/-internals/runtime';
import { cond, isObject, identity, stubTrue, flip, conforms, isString, stubFalse } from 'lodash';

const state = {};

const getCounters = (params) => returnOrCreate(state[params.id], params.id);

const create = (id) =>
  (state[id] = EmberObject.create({
    members: 0,
    admins: 0,
    invited: 0,
    pending: 0,
    isFetching: true,
  }));

const returnOrCreate = cond([
  [isObject, identity],
  [stubTrue, flip(create)],
]);

const getState = cond([
  [conforms({ id: isString }), getCounters],
  [stubTrue, stubFalse],
]);

const self = EmberObject.extend(ActionHandler, {
  getState: getState,

  actions: {
    handle: (id, data) => {
      getState({ id: id }).setProperties(data);
    },
  },
});

export default self.create();
